/* import __COLOCATED_TEMPLATE__ from './checkout-link-qr-code-modal.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { buttonClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
function generateQRCodeEvent(label, action, {
  linkType,
  id
}) {
  const metadata = {
    page_click_detail: `${linkType}: ${id}`
  };
  return buttonClickEvent(`${label}: ${action}`, metadata);
}
let CheckoutLinkQrCodeModal = (_dec = computed('qrCodeImageData'), (_class = class CheckoutLinkQrCodeModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modal", _descriptor, this);
    _initializerDefineProperty(this, "eventstream", _descriptor2, this);
    _initializerDefineProperty(this, "checkoutLinkSharing", _descriptor3, this);
    _defineProperty(this, "qrCodeImageData", null);
  }
  get qrCodeImageSrc() {
    return `data:image/png;base64, ${this.qrCodeImageData}`;
  }
  click(event) {
    event.stopPropagation();
  }
  async didReceiveAttrs() {
    super.didReceiveAttrs();
    if (this.modalOptions.model) {
      this.set('model', this.modalOptions.model);
      const qrCodeImageData = await this.checkoutLinkSharing.generateQrCode(this.model, 120, 120);
      this.set('qrCodeImageData', qrCodeImageData);
      this.eventstream.track(generateQRCodeEvent(this.modalOptions.eventLabel, 'Show QR Code', this.model));
    }
  }
  close() {}
  downloadQRCode() {
    this.eventstream.track(generateQRCodeEvent(this.modalOptions.eventLabel, 'Download QR Code', this.model));
  }
  cancel() {
    if (this.modal.isOpen) {
      this.close();
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checkoutLinkSharing", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "qrCodeImageSrc", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "qrCodeImageSrc"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "downloadQRCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "downloadQRCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype)), _class));
export { CheckoutLinkQrCodeModal as default };